import { Link } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import { INTERCOM_LAUNCHER_PROPS } from '../../../../../Intercom';
import locales from './locales';

interface UnderReviewProps {
  inviterName: string;
  beneficiaryEmail: string;
}

/**
 * A page allowing the beneficiary to see that their application is sent.
 */
const UnderReview = asBentoPage<UnderReviewProps>(
  ({ beneficiaryEmail, inviterName, Layout }) => (
    <Layout nav={<OBNavigation />}>
      <Heading marginBottom="space-16" size="lg">
        {locales.title}
      </Heading>
      <Text marginBottom="space-16">
        {locales.formatString(locales.notifiedInviteName, { inviterName })}
      </Text>
      <Text>
        {locales.formatString(locales.receiveNotifications, {
          beneficiaryEmail,
        })}
      </Text>
      <Text fontWeight="weight-500" marginY="space-48">
        {locales.quitPage}
      </Text>
      <Text variant="primary">
        {locales.question}{' '}
        <Link
          {...INTERCOM_LAUNCHER_PROPS}
          textDecoration="none"
          variant="inline"
        >
          {locales.contactUs}
        </Link>
      </Text>
    </Layout>
  ),
);

export default UnderReview;
